import { render, staticRenderFns } from "./PlaceAdd.vue?vue&type=template&id=7f570e71&scoped=true&"
import script from "./PlaceAdd.vue?vue&type=script&lang=js&"
export * from "./PlaceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f570e71",
  null
  
)

export default component.exports